import { useState } from "react";

function normalizeRequestValue(value) {
  return typeof value === "string" ? value : "";
}

export default function useErrorsCenterController() {
  const [openRequest, setOpenRequest] = useState({
    errorId: "",
    filter: "",
    openAll: false,
    scroll: true,
    source: "",
    token: 0,
    viewName: "errors",
  });

  const openErrorsPanel = ({ errorId = "", filter = "", openAll = false, scroll = true, source = "", viewName = "errors" } = {}) => {
    setOpenRequest((currentRequest) => ({
      errorId: normalizeRequestValue(errorId),
      filter: normalizeRequestValue(filter),
      openAll: openAll === true,
      scroll: scroll !== false,
      source: normalizeRequestValue(source),
      token: currentRequest.token + 1,
      viewName: normalizeRequestValue(viewName) || "errors",
    }));
  };

  return {
    openErrorsPanel,
    openRequest,
  };
}